import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { Title } from "./GlobalMassssage";
import { AuthContext } from "../../Context/ContextFunctions";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { authDetails, isAccessible } = useContext(AuthContext);
  const storedAuth = JSON.parse(localStorage.getItem("login"));
  const token = storedAuth?.logInItem?.token;
  let title;

  // Check if the current route is "/login"
  const isLoginPage =
    location.pathname === "/login" || location.pathname === "/logout";

  useEffect(() => {
    if (
      token === null ||
      token === undefined ||
      token === "" ||
      isLoginPage ||
      storedAuth?.logInItem?.isAdminUser === false
      // storedAuth?.logInItem?.roleTypeID !== 1
    ) {
      localStorage.clear(); // Clear localStorage
      navigate("/login");
    } else {
    }
  }, []);

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        title = "Dashboard | " + Title;
        break;

        break;
      case "/lead":
        if (isAccessible?.Lead?.canView) {
          title = "Lead | " + Title;
        } else {
          navigate("/");
        }
        break;
      case "/enquiry-received":
        if (isAccessible?.EnquiryReceived?.canView) {
          title = "Enquiry Received | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/estBoq":
        if (isAccessible?.EstBoq?.canView) {
          title = "Est & Boq | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/quotation":
        if (isAccessible?.Quotation?.canView) {
          title = "Quotation | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/product":
        if (isAccessible?.Product?.canView) {
          title = "Product | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/employee":
        if (isAccessible?.Employee?.canView) {
          title = "Employee | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/assignSitePage":
        title = "Assign Site | " + Title;
        break;
      case "/company":
        if (isAccessible?.Company?.canView) {
          title = "Company | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/followup":
        if (isAccessible?.FollowUp?.canView) {
          title = "Followup | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/termsAndCondition":
        if (isAccessible?.TermsAndCondition?.canView) {
          title = "Terms And Condition | " + Title;
          break;
        } else {
          navigate("/");
        }

      case "/designation":
        if (isAccessible?.Designation?.canView) {
          title = "Designation | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/unit":
        if (isAccessible?.Unit?.canView) {
          title = "Unit | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/site":
        if (isAccessible?.Site?.canView) {
          title = "Site | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/source":
        if (isAccessible?.Source?.canView) {
          title = "Source | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/user-role":
        if (isAccessible?.RoleType?.canView) {
          title = "User Role | " + Title;
        } else {
          navigate("/");
        }
        break;
      case "/country":
        if (isAccessible?.Country?.canView) {
          title = "Country | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/state":
        if (isAccessible?.State?.canView) {
          title = "State | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/district":
        if (isAccessible?.District?.canView) {
          title = "District | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/taluka":
        if (isAccessible?.Taluka?.canView) {
          title = "Taluka | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/midc":
        if (isAccessible?.MIDC?.canView) {
          title = "IDC | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/fieldAttendanceReport":
        title = "Field Attendance Report | " + Title;
        break;
      case "/unProcessedLead":
        title = "Unprocessed Lead | " + Title;
        break;
      case "/unProcessedEnquiry":
        title = "Unprocessed Enquiry | " + Title;
        break;
      case "/detailedLog":
        title = "Logs | " + Title;
        break;
      case "/viewQuotation":
        title = "Quotation | " + Title;
        break;
      case "/salesLog":
        if (isAccessible?.SalesLog?.canView) {
          title = "Sales Log | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/accountLog":
        if (isAccessible?.AccountLog?.canView) {
          title = "Account Log | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/invoice":
        title = "Invoice | " + Title;
        break;
      case "/profile":
        title = "Profile | " + Title;
        break;
      case "/login":
        title = "Login | " + Title;
        break;
      case "/dvr":
        if (isAccessible?.DVR?.canView) {
          title = "DVR | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/followup":
        if (isAccessible?.FollowUp?.canView) {
          title = "Followup | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/customer":
        if (isAccessible?.Customer?.canView) {
          title = "Customers | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/logout":
        title = "Logout | " + Title;
        break;
      case "/Company":
        if (isAccessible?.Company?.canView) {
          title = "Company | " + Title;
        } else {
          navigate("/");
        }

        break;
      case "/account-report":
        title = "Account Report | " + Title;
        break;
      case "/previewPO":
        title = " PO Preview | " + Title;
        break;
      case "/previewInvoiceReceipt":
        title = " Invoice Receipt | " + Title;
        break;
      case "/preViewInvoice":
        title = " Invoice Preview | " + Title;
        break;
      case "/unProcessedQuotation":
        title = " Unprocessed Quotation | " + Title;
        break;
      case "/task-management":
        title = " Task Management| " + Title;
        break;
      case "/help-requested-list":
        title = "Help requested list | " + Title;
        break;
      case "/notes-attachments-list":
        title = "Notes & Attachments list | " + Title;
        break;
      case "/unprocessed-order":
        title = "Unprocessed Orders | " + Title;
        break;
      default:
        navigate("/login");
        break;
    }
    document.title = title;
  }, [location?.pathname]);

  return (
    <div className="min-h-screen bg-white-100 flex flex-col sticky">
      {/* Render Navbar only if not on login page */}
      {!isLoginPage && <Navbar />}

      <main
        className={`flex-grow mx-auto px-1 py-1 w-full  ${
          isLoginPage ? "flex items-center justify-center" : ""
        }`}
      >
        {children}
      </main>
      {/* Render Footer only if not on login page */}
      {!isLoginPage && (
        <footer
          style={{
            background: "white",
            zIndex: 1000,
          }}
          className="bg-white dark:bg-dark-800 sticky bottom-0"
        >
          <div className="w-full mx-auto max-w-screen-xl p-2 md:flex md:items-center md:justify-between">
            <span
              style={{
                color: "gray",
                fontWeight: "bold",
                fontFamily: "roboto",
                fontSize: "14px",
                margin: "auto",
              }}
            >
              © 2025-2026 <a>Surya Group</a>. All Rights Reserved.
            </span>
          </div>
        </footer>
      )}
    </div>
  );
};

export default Layout;
